export default __webpack_public_path__ + "static/media/SharingAudio.70b067dc.mp4";